let customSelects = document.getElementsByClassName("custom-select");

if(customSelects.length) {
    
  // Loop through each custom-select element:
  Array.from(customSelects).forEach(customSelect => {
    let selectElement = customSelect.getElementsByTagName("select")[0];

    // Create a DIV for the selected item:
    let selectedDiv = document.createElement("DIV");
    selectedDiv.className = "select-selected";
    selectedDiv.innerHTML = "<span>" + selectElement.options[selectElement.selectedIndex].innerHTML + "</span>";
    customSelect.appendChild(selectedDiv);

    // Create a DIV for the option list:
    let optionsDiv = document.createElement("DIV");
    optionsDiv.className = "select-items select-hide";

    // Loop through each option in the select element:
    Array.from(selectElement.options).forEach((option, j) => {
      let optionDiv = document.createElement("DIV");
      optionDiv.innerHTML = option.innerHTML;
      optionDiv.dataset.variant = option.value;

      // Add click event listener to update the select box:
      optionDiv.addEventListener("click", function(e) {
        selectElement.selectedIndex = j;
        selectedDiv.innerHTML = "<span>" + this.innerHTML + "</span>";
        let sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected");
        Array.from(sameAsSelected).forEach(s => s.classList.remove("same-as-selected"));
        this.classList.add("same-as-selected");
        document.getElementById('upsell-variant').value = this.dataset.variant;
        selectedDiv.click();
      });

      optionsDiv.appendChild(optionDiv);
    });

    customSelect.appendChild(optionsDiv);

    // Add click event listener to toggle the select box:
    selectedDiv.addEventListener("click", function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  });

  // Function to close all select boxes except the current one:
  function closeAllSelect(elmnt) {
    let selects = document.getElementsByClassName("select-items");
    let selectedDivs = document.getElementsByClassName("select-selected");
    Array.from(selectedDivs).forEach(selectedDiv => {
      if (elmnt != selectedDiv) {
        selectedDiv.classList.remove("select-arrow-active");
      }
    });
    Array.from(selects).forEach(select => {
      if (elmnt != select.previousSibling) {
        select.classList.add("select-hide");
      }
    });
  }

  // Close all select boxes when the user clicks anywhere outside:
  document.addEventListener("click", closeAllSelect);
}